import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'

@Component({
    templateUrl: './AppViews/ChangeRequest/ChangeRequestList.html',
    styles: [`
    .large-tooltip .tooltip-inner{
        width: 1250px;
        max-width: 1250px;
    }
  `],
   
  
})

export class ChangeRequestListComponent implements OnInit {
    public showLoader = false;
    filter: any = {  'ProjectId': "",'ModuleId': "", 'StatusId': "",'Search':""};
    filterFlag: any;
    search: any = "";
    userDetail: any;
    getProjectUrl: any;
    constants: Constants;
    projectItems: any = [];
    StatusList: any = [];
    ModuleList: any = [];
    assigneeItems: any = [];
    changeRequestItems: any = [];
    isVisible: boolean = true;
    statusFlag:any;
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.statusFlag=0;
        //this.filter.StageId = this.constants.enumIssueStage["Open"];
          this.filterFlag=JSON.parse(localStorage.getItem('CRFilters'));
          if(this.filterFlag!=null && typeof this.filterFlag != 'undefined'){
            this.filter=JSON.parse(localStorage.getItem('CRFilters'));
            this.search=this.filter.search;
            this.statusFlag=1;
            localStorage.removeItem("CRFilters")
           
        //  this.getProjectUrl="BugTracker/GetAssignedIssue"    
                                                                               }   

           this.filter.FromDate=moment().format('DD/MM/YYYY');
        this.filter.ToDate=moment().format('DD/MM/YYYY');
    }
    ngAfterViewInit() {


    }

    ngOnInit() {

        this.bindFilters();
        this.getChangeRequestList();
        
        
    }

    
LoadDate(){
    $('.date').datetimepicker({
        format: 'DD/MM/YYYY'
    });
    
}

GetModule(ProjectId,from) {


       
        this.showLoader = true;

        
        this._httpService.ajaxPost("ProjectModule/GetProjectModule",
            { "ProjectId": ProjectId }).subscribe(
            data => {
              
                  if(data["ProjectModuleList"].length >0){
                this.ModuleList = data["ProjectModuleList"];
                  }
                  else{
                       let objItem: any = {};
                   
                    objItem.ProjectId = ProjectId;
                    objItem.ModuleName = "Main";;
                  //  objItem.ModuleId =0;
                   
             this._httpService.ajaxPost('ProjectModule/AddUpdateProjectModule',objItem).subscribe(
            data => {

                this.GetModule(ProjectId,null);
              
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
        );
                  }
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }

            );
           

    }

    bindFilters() {

        this.showLoader = true;
        var userId = 0;
        var TeamId = 0;

        this._httpService.ajaxPost("Project/GetAssignedProject", {  "ProjectId": 0, "OwnerTeamId": TeamId, "ProjectType": 0, "Status": 0, "UserId":  this.userDetail.SiteUserId,}).subscribe(
            data => {

  
                  this.projectItems = data["ProjectList"];
                  console.log("123456"+data["ProjectList"])
                     
                    },
                    err => {
                       
                        this.showLoader = false;
                    },
                    () => {
                       
                        this.showLoader = true;
                        this._httpService.ajaxPost('Common/GetParameter',
                            { "ParameterTypeId": this.constants.enumParamterTypeName["ServiceRequestStatusType"] }).subscribe(
                            data => {
                                this.StatusList = data["Parameter"];
                            },
                            err => {
                                this.showLoader = false;
                            },

                            () => {
                                  this.showLoader = true;
                                  this._httpService.ajaxPost('BugTracker/GetUser').subscribe(
                                  data => {
                                      
                                  this.assigneeItems = data["UserList"];
                                           },
                                                                    err => {

                                                                        this.showLoader = false;
                                                                    },
                                                                    () => {
                                                                        this.showLoader = false;
                                                                    }

                                                                ); this.showLoader = false;

                                                            }); this.showLoader = false;

                                              

                                       

                                                });
                                      }
    setFilters() {
  
        this.filter = {  'ProjectId': this.filter.ProjectId, 'StatusId': this.filter.StatusId, 'ModuleId': this.filter.ModuleId, 'Search': this.search };
        localStorage.setItem("CRFilters",JSON.stringify(this.filter));
    }


    getChangeRequestList() {

        var userId = 0;
        userId = this.userDetail.SiteUserId;
       
        this.showLoader = true;
        this._httpService.ajaxPost("ChangeRequest/getChangeRequestList",
            { 'ProjectId': this.filter.ProjectId,'ModuleId': this.filter.ModuleId,'StatusId': this.filter.StatusId,'UserId': userId }).subscribe(

            data => {
                 this.changeRequestItems = data["ChangeRequestList"];
                    },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
            );

        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
   }

 public clearFilter() {
        this.filter = {'ProjectId': "", 'ModuleId': "", 'StatusId': "",'Search': ""};
        this.getChangeRequestList();
        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }


}




/** WEBPACK FOOTER **
 ** ./TypeScripts/ChangeRequest/ChangeRequestList.component.ts
 **/